import React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import { withRouter } from "react-router";
import { withTranslation } from "react-i18next";

import axios from "../../components/Axios";

// Stripe returns here after a payment method is set up: confirm it with the API, then go back to Billing
class Index extends React.Component {
  async componentDidMount() {
    const params = Object.fromEntries(new URLSearchParams(window.location.search).entries());
    await axios.post("/user/stripe/intent", params);
    this.props.history.push("billing");
  }

  render() {
    const { t } = this.props;
    return (
      <div className="ac-narrowpage">
        <section className="ac-card" aria-labelledby="ac-saving-h">
          <div className="ac-head">
            <h2 id="ac-saving-h" className="ac-title">
              {t("Saving Payment Method")}
            </h2>
          </div>
          <div className="ac-body">
            <CircularProgress size={24} />
          </div>
        </section>
      </div>
    );
  }
}

export default withTranslation()(withRouter(Index));
